class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    const _this = this;

    this.input = this.querySelector('input[type="search"]');
    this.clear = this.querySelector('[data-clear]');
    this.predictiveSearchResults = this.querySelector('[data-results]');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    document.addEventListener('keyup', (e) => {
      if (e.key === "Escape") { // escape key maps to keycode `27`
        _this.clearResults();
        _this.hideResults();
      }
    });

    this.clear.addEventListener('click', function() {
      console.log(this);
      _this.clearResults();
      _this.hideResults();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    console.log(searchTerm.length);
    if(searchTerm.length) {
      this.clear.classList.add('active');
    }
    else {
      this.clear.classList.remove('active');
    }

    console.log(`Search Term: ${searchTerm}`);

    if (!searchTerm.length) {
      this.hideResults();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.clearResults();
          this.hideResults();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.showResults();
      })
      .catch((error) => {
        this.clearResults();
        this.hideResults();
        throw error;
      });
  }

  clearResults() {
    this.predictiveSearchResults.innerHTML = "";
    this.input.value = "";
    this.clear.classList.remove('active');
    console.log(this.input);
  }

  open() {

    this.setAttribute('aria-hidden', "false");
    this.input.focus();
  }

  close() {
    this.setAttribute('aria-hidden', "true");
    this.input.blur();
  }

  showResults() {
    this.predictiveSearchResults.setAttribute('aria-hidden', "false");
  }

  hideResults() {
    this.predictiveSearchResults.setAttribute('aria-hidden', "true");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);